import H2Base from "../../../components/ui/titles/H2Base";
import {
    AllocationVisual,
    CompaniesVisual,
    DocumentsVisual,
    ReinvestVisual,
    RiskCostVisual,
    SecurityVisual,
} from "./JourneyVisuals";

const steps = [
    {
        title: "Ouvrir un compte",
        text: "La création de votre compte investisseur s'effectue entièrement en ligne, sur la base de vos justificatifs et d'un questionnaire réglementaire.",
        goodToKnow: "un justificatif d'identité de moins de 3 mois, un RIB, une validation numérique de votre identité et le questionnaire investisseur requis par la réglementation PSFP (test de connaissances et d'expérience) suffisent à finaliser l'ouverture de votre compte.",
        Visual: DocumentsVisual,
    },
    {
        title: "Découvrir les entreprises financées",
        text: "Les dossiers proviennent de courtiers en financement professionnel partenaires, puis passent par le scoring propriétaire de PretUp.",
        goodToKnow: "seules des PME françaises in bonis et profitables, réalisant entre 250 K€ et 20 M€ de chiffre d'affaires, sont retenues — pour des besoins liés au cycle d'exploitation (BFR, recrutement, stocks, investissement).",
        Visual: CompaniesVisual,
    },
    {
        title: "Choisir son mode d'investissement",
        text: "Investissez prêt par prêt selon vos préférences, ou confiez votre allocation au module Boost pour un portefeuille diversifié automatique.",
        goodToKnow: "la gestion privée Boost PretUp, dès 50 000 € à 100 000 €, répartit automatiquement vos fonds sur plusieurs secteurs — sans frais de gestion.",
        Visual: AllocationVisual,
    },
    {
        title: "Sûreté et sécurité des fonds",
        text: "Chaque prêt est adossé à une sûreté adaptée à son profil de risque, et vos fonds sont séquestrés chez un établissement bancaire de premier plan.",
        goodToKnow: null,
        Visual: SecurityVisual,
    },
    {
        title: "Suivre vos remboursements",
        text: "Chaque entreprise financée rembourse son prêt par mensualités (capital et intérêts), directement visibles depuis votre espace investisseur.",
        goodToKnow: "en cas d'incident, PretUp pilote pour vous le recouvrement amiable puis judiciaire, avec l'appui d'un réseau d'huissiers partenaires.",
        Visual: RiskCostVisual,
    },
    {
        title: "Réinvestir au fil de l'eau",
        text: "Chaque mois, les échéances encaissées (capital et intérêts) peuvent être réinvesties directement dans de nouveaux prêts, au fil de l'eau.",
        goodToKnow: "vous restez libre de réinvestir vos remboursements ou de les retirer selon vos besoins, à tout moment.",
        Visual: ReinvestVisual,
    },
];

const InvestorJourney = () => {
    return (
        <section id="parcours" className="py-16 md:py-20">
            <div className="max-w-2xl">
                <H2Base text="Le parcours investisseur" tailwindClass="text-2xl md:text-3xl" />
                <p className="leading-relaxed text-gray-600">
                    De l'ouverture de compte au versement des intérêts, un chemin simple et encadré.
                </p>
            </div>

            <div className="mt-6">
                {steps.map(({ title, text, goodToKnow, Visual }, index) => (
                    <div
                        key={title}
                        className="grid grid-cols-1 items-center gap-8 border-t border-gray-200 py-12 first:border-t-0 lg:grid-cols-2 lg:gap-16"
                    >
                        <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                            <p className="mb-4 flex items-center gap-2.5 text-sm font-semibold italic text-accent">
                                <span className="h-px w-8 bg-accent" />
                                Étape {index + 1}
                            </p>
                            <h3 className="text-xl font-bold leading-snug text-secondaryDark md:text-2xl">{title}</h3>
                            <p className="mt-3 max-w-lg leading-relaxed text-gray-600">{text}</p>

                            {goodToKnow && (
                                <p className="mt-5 max-w-lg rounded-xl border border-l-4 border-gray-200 border-l-accent bg-white p-4 text-sm leading-relaxed text-gray-600">
                                    <b className="font-semibold text-secondary">Bon à savoir :</b> {goodToKnow}
                                </p>
                            )}
                        </div>

                        <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                            <Visual />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default InvestorJourney;
